import {
  AppRolesApi,
  AppRolesGetActiveRoleAssignmentsRequest,
  AppRolesGetAvailableRolesRequest,
  AppRolesGetAvailableSecurityGroupsRequest,
  AppRolesUpdateRoleAssignmentsPostRequest,
  GuidReferenceReadModelPagedList,
  RolesAndAssignmentsReadModel,
  StringReferenceReadModelPagedList,
  UpdateRoleAssignmentsResponse,
} from "../../../@api";

import { IStoreContext } from "../../stores/StoreContext";
import { AppRolesApiService } from "../ApiServices/AppRolesApiService";
import GenericService from "../GenericService";

export class AppRolesService extends GenericService<AppRolesApi, AppRolesApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, AppRolesApi, AppRolesApiService);
  }

  public getAvailableRoles(
    requestParameters?: AppRolesGetAvailableRolesRequest,
  ): Promise<GuidReferenceReadModelPagedList> {
    return this.apiService.appRolesGetAvailableRoles(requestParameters);
  }

  public getAvailableSecurityGroups(
    requestParameters?: AppRolesGetAvailableSecurityGroupsRequest,
  ): Promise<StringReferenceReadModelPagedList> {
    return this.apiService.appRolesGetAvailableSecurityGroups(requestParameters);
  }

  public getActiveRoleAssignments(
    requestParameters?: AppRolesGetActiveRoleAssignmentsRequest,
  ): Promise<RolesAndAssignmentsReadModel> {
    return this.apiService.appRolesGetActiveRoleAssignments(requestParameters);
  }

  public updateRoleAssignments(
    requestParameters?: AppRolesUpdateRoleAssignmentsPostRequest,
  ): Promise<UpdateRoleAssignmentsResponse> {
    return this.apiService.appRolesUpdateRoleAssignmentsPost(requestParameters);
  }
}
